import { DISPLAY_MESSAGE, CLEAR_MESSAGE } from '../actions/types';

import { MESSAGE_LEVEL_DEFAULT } from '../utils/Constants';

const INITIAL_STATE = {
	text: '',
	level: MESSAGE_LEVEL_DEFAULT
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case DISPLAY_MESSAGE:
			return action.payload;
		case CLEAR_MESSAGE:
			return INITIAL_STATE;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/MessageReducer.js